import React from 'react';
import { motion } from 'framer-motion';
import { format, addDays, startOfWeek } from 'date-fns';

interface HabitStreakProps {
  history: Array<{
    date: string;
    completed: boolean;
  }>;
  days?: number;
}

export function HabitStreak({ history, days = 7 }: HabitStreakProps) {
  const startDate = startOfWeek(new Date());
  const weekDays = Array.from({ length: days }, (_, i) => addDays(startDate, i));

  return (
    <div className="grid grid-cols-7 gap-1">
      {weekDays.map((date, index) => {
        const dateStr = format(date, 'yyyy-MM-dd');
        const entry = history.find(h => h.date === dateStr);
        const isToday = format(new Date(), 'yyyy-MM-dd') === dateStr;

        return (
          <motion.div
            key={dateStr}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.05 }}
            className={`aspect-square rounded-lg flex items-center justify-center relative ${
              isToday ? 'ring-2 ring-primary' : ''
            } ${
              entry?.completed
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted/30'
            }`}
          >
            <span className="text-xs">{format(date, 'd')}</span>
            {isToday && (
              <div className="absolute inset-0 bg-primary/20 animate-pulse rounded-lg" />
            )}
          </motion.div>
        );
      })}
    </div>
  );
}